import { useState, useRef } from "react";
import { Col, Row, Card, CardText, Form, CardBody } from "reactstrap";
// drop
import Dropzone from "react-dropzone";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// leitor
import readXlsxFile from "read-excel-file";
// modelo
import ModeloUpload from "../../../assets/statics/modelo_push_atualizar.xlsx";
// validações e utils
import {
  allExcelColumnsUpdate,
  findRowsWithError,
  excelColumnsUpdatePtBr,
  validationIds,
  validationDate,
  formateDate,
  validationDateInBase,
} from "./ImportValidation";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
// componentes
import ModalExcelRows from "../Voo/ModalExcelRows";
//service
import { updateNotification } from "../../../utils/services/notification";

export default function ImportUpdate(props) {
  const { idEvent, toggleModal, getData } = props;
  // documento
  const [selectedFiles, setselectedFiles] = useState([]);
  // linhas do doc
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  // botoes
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  const importActivated = useRef(false);
  // modal de erros no arquivo xlsx
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);
  // alerta
  const [success_dlg, setsuccess_dlg] = useState(false);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;
    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      Id: {
        prop: "id",
        type: String,
      },
      Titulo: {
        prop: "title",
        type: String,
      },
      Mensagem: {
        prop: "message",
        type: String,
      },
      Data: {
        prop: "date",
        type: String,
      },
      Hora: {
        prop: "hour",
        type: String,
      },
    };

    let count = 1;

    const readXlsx = async () => {
      const { rows } = await readXlsxFile(selectedFiles[0], { schema });
      const validateRows = rows.map((row, i) => allExcelColumnsUpdate(row, i));
      const rowsWithError = findRowsWithError(validateRows);

      setTotalRows(validateRows.length);

      // validar colunas se esta no padrão
      const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
      const header = rowsWithoutSchema[0];
      const schemaCreate = Object.keys(schema);

      function isEqual(schema, header) {
        if (schema.length !== header.length) return false;

        return (
          schema.every((item) => header.includes(item)) &&
          header.every((item) => schema.includes(item))
        );
      }

      if (!isEqual(schemaCreate, header)) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      if (rowsWithError.length > 0 || rows.length === 0) {
        setErrors(rowsWithError);
        setModalErrors(true);
        return;
      }

      const valideIds = await validationIds(validateRows, idEvent);

      if (valideIds.length > 0) {
        setErrors(valideIds);
        setModalErrors(true);
        return;
      }

      const getDatesInvalids = await validationDate(validateRows);

      if (getDatesInvalids.length > 0) {
        setErrors(getDatesInvalids);
        setModalErrors(true);
        return;
      }

      const validDateInBase = await validationDateInBase(validateRows, idEvent);

      if (validDateInBase.length > 0) {
        setErrors(validDateInBase);
        setModalErrors(true);
        return;
      }

      for (const row of validateRows) {
        await importPushs(row, validateRows.length);
      }
    };

    readXlsx();

    async function importPushs(row, totalRows) {
      const data = {
        title: row.title,
        text: row.message,
        date: await formateDate(row.date, row.hour),
        hour: row.hour,
        event: idEvent,
        schedule: true,
      };

      const res = await updateNotification(data, "", row.id);

      if (res.message === "NOTIFICATION_UPDATED") {
        setTotalSended(count++);
      }

      if (count === totalRows || (count === 2 && totalRows === 1)) {
        setsuccess_dlg(true);
      }
    }
  }

  return (
    <>
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsUpdatePtBr}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            getData();
            toggleModal();
            setsuccess_dlg(false);
          }}
        >
          {"O arquivo foi enviado com sucesso!"}
        </SweetAlert>
      ) : null}

      <Card className="p-1">
        <CardBody className="m-1 p-2">
          <CardText className="mb-2 p-10">
            O arquivo a ser importado deve seguir este{" "}
            <a href={ModeloUpload} download="modelo_push_atualizar.xlsx">
              Modelo
            </a>
            , não modifique seu cabeçalho.
          </CardText>

          <Form>
            {selectedFiles.length === 0 && (
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-1"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-4">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                        <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}

            <div className="dropzone-previews mt-0" id="file-previews">
              {selectedFiles.map((f, i) => {
                return (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + "-file"}
                  >
                    <div className="p-1">
                      <Row className="align-items-center">
                        <Col xs="11">
                          <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                        </Col>
                        <Col xs="1">
                          <span
                            style={{
                              fontSize: "16px",
                              color: "red",
                              fontWeight: "700",
                            }}
                            className="mdi mdi-close"
                            onClick={() => setselectedFiles([])}
                          />
                        </Col>
                      </Row>
                      {importActivated.current && (
                        <Row className="align-items-center">
                          <Col>
                            <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          </Form>

          <div className="text-center mt-3">
            <button
              type="button"
              disabled={!btnSend}
              className="btn btn-primary waves-effect waves-light"
              onClick={() => uploadService()}
            >
              Enviar Push
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={() => cancelImport()}
            >
              Cancelar
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
